import classNames from "shared/utils/classNames";

export function LoadingSpinner() {
  const sharedClassName = classNames("absolute border-2 border-solid");

  return (
    <>
      <div
        className={classNames(
          sharedClassName,
          "h-full w-full rounded-2xl opacity-25",
        )}
      />
      <div
        className={classNames(
          sharedClassName,
          "h-full w-full rounded-2xl",
          "animate-spin border-r-transparent",
        )}
      />
    </>
  );
}

export default LoadingSpinner;
